type VaffaMarkProps = {
  className?: string;
  title?: string;
};

export function VaffaMark({ className = "", title }: VaffaMarkProps) {
  return (
    <svg
      className={`vaffa-mark ${className}`.trim()}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title}
    >
      <path
        className="vaffa-mark__bubble"
        d="M13 8h38a8 8 0 0 1 8 8v25a8 8 0 0 1-8 8H31L18 58l3-9h-8a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8Z"
      />
      <path
        className="vaffa-mark__wave"
        d="M17 30v4m7-11v18m8-25v32m8-24v16m7-10v4"
      />
    </svg>
  );
}
